import app, { Component } from 'apprun';
import { isValid, lookup_en } from '../utils';
import { users } from '../api';

export default class UserPropertyComponent extends Component {
    state = { }

    view = (state) => {
      if (!state.item) {return;}
      let award = '', year = '', publicInd = '';
      const separator = ' >> ';

      const years =Array(50).fill(5).map((item, index) => 1980 + index);

      if(state.item.value){
        const awardArray = state.item.value.split(separator);

        award = awardArray[0];
        year = awardArray[1]==='0'? '': awardArray[1];
        publicInd = awardArray[2];
      }else{
        publicInd = '1';
      }

      return (
        <div>
          <form id="AwardEditForm" class="form-horizontal" style={{ width: '450px' }}>
            <div class="row">
              <div class="row">
                <span class="col-sm-8">Award</span>
                <span class="col-sm-2">Year</span>
                <span class="col-sm-2">Public</span>
              </div>
              <div class="row">
                <span class="col-sm-8">
                  <select id="selectedaward" name="award" oninput={e => award = (e.target.options[e.target.selectedIndex].text)} data-validate>
                    <option value=' '>[Select]</option>
                    {lookup_en.AdminAwards.map(r => <option value={r.id} selected={r.value === award ? 'selected' : null}>{r.value}</option>)}
                  </select>
                &nbsp;
                </span>
                <span class="col-sm-2">
                  <select id="awardYear" name="awardYear" oninput={e => year = (e.target.options[e.target.selectedIndex].text)} data-validate>
                    <option value=' '>[Select]</option>
                    {years.map(r => <option value={r} selected={r.toString() === year ? 'selected' : null}>{r.toString()}</option>)}
                  </select>
                &nbsp;
                </span>

                <span class="col-sm-2">
                  <input
                    name="publicInd"
                    type="checkbox"
                    checked={publicInd === '1' ? 'checked' : null}
                    onchange={(e) => {
                      publicInd = e.target.checked? '1': '0';
                    }}

                  />
                    &nbsp;
                </span>
              </div>
              <div class="row">
                <div id="selectedawardErrMsg" class="text-danger col-sm-8"></div>
                <div id="awardYearErrMsg" class="text-danger col-sm-2"></div>
              </div>
            </div>
            <div class="edit-buttons">
              <a
                type="button"
                class="btn btn-primary btn-xs"
                style={(state.item.required || (state.item.value===''))?{ display:'none' }:{ display:'inline-block' }}
                onclick={() => state.caller.run(state.delete, state.item, state.panelId)}>
            delete
              </a>
              <a
                type="button"
                class="btn btn-primary btn-xs"
                onclick={e => this.run('save', e, award, year, publicInd)}>
            save
              </a>
              <a type="button" class="btn btn-default btn-xs" onclick={() => this.run('cancel')}>
            cancel
              </a>
            </div>
          </form>

          {state.auditLog?
            <div>
              <p>Update History</p>
              <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover" style=" white-space: normal;">
                <thead>
                  <tr>
                    <th>Public indicator</th>
                    <th>Modified Date</th>
                    <th>Modified User</th>
                  </tr>
                </thead>
                <tbody>
                  {state.auditLog.map((item) => {
                    return (
                      <tr style={{ display: 'table-row' }}>
                        <td>{item.publicIndDesp}</td>
                        <td>{item.modifiedDate?.substring(0, 10)}</td>
                        <td>{item.auditModifiedUser}</td>
                      </tr>
                    );
                  }
                  )}
                </tbody>
              </table></div> : ''}
        </div>
      );
    };

  update = {
    refresh: async (state, newState) => {
      state = newState;

      let year = '', awardId = '';
      const separator = ' >> ';

      if (state.item.value) {
        const awardArray = state.item.value.split(separator);
        year = awardArray[1] === '' ? '0' : awardArray[1];
        awardId = awardArray[3];

        state.auditLog = await users.getAuditPersonAwardPublicInd(state.personId, awardId, year);
      } else {
        state.auditLog = [];
      }

      return { ...state, ...newState };
    },

    save: (state, e, award, year, publicInd) => {
      state.newVal = award + ' >> ' + year + ' >> ' + publicInd;
      if(!isValid('AwardEditForm')) { e.preventDefault(); return;}
      state.caller.run(state.save, state.item, state.panelId, state.newVal);
    },

    cancel: (state) => {
      state.caller.run(state.cancel, state.panelId);
    },
  }
  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
